import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Link,
  IconButton,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
  Facebook,
  Twitter,
  Instagram,
  Phone,
  Email,
  LocationOn,
} from '@mui/icons-material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Gudiya Cooking Recipe
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Bringing you authentic flavors and joyful cooking experiences. Your destination for delicious recipes and real homemade taste. Discover authentic flavors, one recipe at a time.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
              <Link href="#" color="inherit" sx={{ textDecoration: 'none' }}>
                <IconButton color="inherit">
                  <Facebook />
                </IconButton>
              </Link>
              <Link href="#" color="inherit" sx={{ textDecoration: 'none' }}>
                <IconButton color="inherit">
                  <Twitter />
                </IconButton>
              </Link>
              <Link href="#" color="inherit" sx={{ textDecoration: 'none' }}>
                <IconButton color="inherit">
                  <Instagram />
                </IconButton>
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/" color="inherit" sx={{ textDecoration: 'none' }}>
                Home
              </Link>
              <Link component={RouterLink} to="/menu" color="inherit" sx={{ textDecoration: 'none' }}>
                Menu
              </Link>
              <Link component={RouterLink} to="/blog" color="inherit" sx={{ textDecoration: 'none' }}>
                Blog
              </Link>
              <Link component={RouterLink} to="/about" color="inherit" sx={{ textDecoration: 'none' }}>
                About
              </Link>
              <Link component={RouterLink} to="/contact" color="inherit" sx={{ textDecoration: 'none' }}>
                Contact
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Contact Info
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 20, mr: 1 }} />
                <Typography variant="body2">+1 234 567 890</Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ fontSize: 20, mr: 1 }} />
                <Typography variant="body2">gudiyacooking@example.com</Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn sx={{ fontSize: 20, mr: 1 }} />
                <Typography variant="body2">123 Main St, Downtown Area</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
